<template>
    <div>
    <q-autocomplete
        @search="searchStates"
        @selected="val => selectMethod(val)"
        ref="stateAutocomplete"
        :min-characters="0"
        />
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'SLStatePicker',    
    props: {
        selected: {
            default: () => {}
        }
    },
    data () {
        return {}
    },    
    computed: {
        ...mapGetters(['autocompleteStateOptions'])
    },
    methods: {
        searchStates(search, done){
            let vm = this
            search = search.toLowerCase().trim()
            console.log(search)
            if(!search){
                done([])
                return vm.selectMethod(null)
            }
            let matches = _.filter(vm.autocompleteStateOptions, x => { return x.label.toLowerCase().indexOf(search) > -1 })
            if(matches.length == 1){
                done([])
                return vm.selectMethod(matches[0])
            }
            return done(matches)
        },
        selectMethod(val){
            if(this.selected){
                this.selected(val ? val.value : null)
            }
        }
    }
}
</script>

<style>
</style>
